import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

import starFilled from 'icons/star-filled.svg';

export const Icon = styled(starFilled)`
	margin-right: 4px;

	&:last-of-type {
		margin-right: 0;
	}
`;

export const Wrapper = styled.div<{ $theme: 'large' | 'small' }>`
  display: flex;

  ${Icon} {
    height: ${p => (p.$theme === 'large' ? '20px' : '16px')};
    width: ${p => (p.$theme === 'large' ? '20px' : '16px')};

    ${minWidth('tablet')} {
      height: ${p => (p.$theme === 'large' ? '32px' : '16px')};
      width: ${p => (p.$theme === 'large' ? '32px' : '16px')};

    }
  }}
`;
